class LangMenuDropdown {
  constructor() {
    this.langMenu = document.querySelector("#lang-menu-trigger")
    //TODO: load only when mobile
    this.initMobileLang()
  }

  initMobileLang() {
    if (!this.langMenu) {
      return
    }

    document.querySelector(".lang-mobile").addEventListener("change", e => {
      e.preventDefault()
      let selectedIndex = document.querySelector(".mobilelanguageSelect")
        .selectedIndex
      let slectedLangValue = document.querySelector(".mobilelanguageSelect")
        .options[selectedIndex].value

      this.openLink(slectedLangValue)
    })
  }

  openLink(culture) {
    const redirectUrl = document.querySelector("[data-sf-role=" + culture + "]")
      .value
    window.location.assign(redirectUrl)
  }
}

export default LangMenuDropdown
